import colors from 'assets/styles/jsVariables/colors';

export default {
  AddressDetailsButtonStyle: {
    height: '45px',
    width: '200px',
    margin: 'auto',
    display: 'inline-block',
    '@media (max-width: 767px)': {
      display: 'block',
    }
  },
  AddressDetailsButtonLabelStyle: {
    fontFamily: 'museosansrounded_500',
    fontSize: '14px',
    letterSpacing: '0.3px',
    textTransform: 'none'
  },
  checkedIconStyle: {
    width: '20px',
    height: '20px',
    fill: colors.lighterCyan,
    strokeWidth: 0.1,
    userSelect: 'none',
    flexShrink: 0,
  },
  uncheckedIconStyle: {
    width: '14px',
    height: '14px',
    borderRadius: '2px',
    stroke: colors.lighterCyan
  },
  inputStyle: {
    width: '26px',
    marginRight: '11px',
    height: '35px',
    border: 'none'
  },
  chevronIconStyle: {
    width: 24,
    height: 24
  },
  chevronIconColor: '#788995'
};



// WEBPACK FOOTER //
// ./src/views/SubscriptionActivate/AddressDetails/style.js